import { render, staticRenderFns } from "./open-credit.vue?vue&type=template&id=a156657c&"
import script from "./open-credit.vue?vue&type=script&lang=js&"
export * from "./open-credit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports